import React from "react";
import PropTypes from "prop-types";

import styles from "./style.css";

export function Rating(props) {
  const { value } = props;
  return (
    <div className={`${styles.rating} ${styles[`star${Math.round(value)}`]}`} />
  );
}

Rating.propTypes = {
  value: PropTypes.number
};
